import { TagSchema } from "@redotech/redo-common-model/tag";
import * as z from "zod";

export const upsertTag = {
  name: "upsertTag" as const,
  input: z.object({ tag: TagSchema }),
  output: TagSchema,
};
